export const experienceData = [
    {
        id: 1,
        company: 'ClickLabs Pvt Ltd',
        jobtitle: 'Software Developer',
        startYear: '2015',
        endYear: '2016'
    },
    {
        id: 2,
        company: 'BlueDolphin',
        jobtitle: 'Senior Software Developer',
        startYear: '2016',
        endYear: '2019'
    },
    {
        id: 3,
        company: 'Go-jek GOTO Company',
        jobtitle: 'Senior Software Consultant',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 4,
        company: 'Deutsche Telekom',
        jobtitle: 'Senior Software Developer',
        startYear: '2020',
        endYear: 'Present'
    }
]